import { useOutletContext } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import { useSearchParams } from 'react-router-dom'

import Loading from 'modules/core/components/Loading'

import NewManualExpensesForm from 'modules/expenses/components/expenses/Detail/_newForm/NewManualExpenseForm'
import { useExpensesNavigation } from 'modules/expenses/hooks/useExpensesNavigation'
import useNewExpensesPage from 'modules/expenses/hooks/useNewExpensesPage'
import type { RouteContextParams } from 'modules/expenses/lib/my_expenses/RouteContextParams'

const NewManualExpensesPage = () => {
  const { group } = useOutletContext<RouteContextParams>()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { navigation } = useExpensesNavigation()

  const {
    customizationFields,
    hasProjectsFeature,
    hasReportOnBehalfFeature,
    loading,
    canCreateExpensesForOthers,
    canCustomizeSettings,
    canSeeEmployeeLegalEntity,
    hasCostCentersFeature,
  } = useNewExpensesPage()

  if (loading) return <Loading inline />

  return (
    <NewManualExpensesForm
      customizationFields={customizationFields}
      hasProjectsFeature={hasProjectsFeature}
      canSeeEmployeeLegalEntity={canSeeEmployeeLegalEntity}
      canCustomizeSettings={canCustomizeSettings}
      hasReportOnBehalfFeature={hasReportOnBehalfFeature}
      canCreateExpensesForOthers={canCreateExpensesForOthers}
      hasCostCentersFeature={hasCostCentersFeature}
      groupCurrency={group?.currency}
      onClose={() =>
        navigate({
          pathname: navigation.helpers.getExpensesFormBackPath(),
          search: searchParams.toString(),
        })
      }
    />
  )
}

export default NewManualExpensesPage
